/* eslint-disable no-undef */
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

if (process.env.REACT_APP_STAGE !== 'prod') {
  console.log('NODE_ENV: ' + process.env.NODE_ENV)
  console.log('Firebase config: ' + process.env.REACT_APP_PROJECT_ID)
}

//firebase config
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
}

// if (
//   process.env.REACT_APP_MEASUREMENT_ID &&
//   process.env.REACT_APP_MEASUREMENT_ID !== ''
// ) {
//   firebaseConfig.measurementId = process.env.REACT_APP_MEASUREMENT_ID
// }

//initialise app
const app = initializeApp(firebaseConfig)
// export default getFirestore()
export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)

export const admin = initializeApp(firebaseConfig, 'Admin')
export const adminAuth = getAuth(admin)

// export { firebaseConfig, db, auth, storage, adminAuth }
